import getB from "../../utils/bridges/EkaBridge";

const useGetWhoAmI = () => {
  const myProfile = getB()?.getMe();
  return { data: myProfile?.user || {} };
};

export default useGetWhoAmI;
